<p>manage-subscription works!</p>
